import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { fadeInUp } from '../../utils/animation';

type RoundedImageStyledProps = {
  url: string;
};

export const RoundedImage = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'url',
})<RoundedImageStyledProps>(({ url, theme }) => ({
  height: 128,
  [theme.breakpoints.up('md')]: {
    height: 192,
  },
  width: '100%',
  backgroundImage: `url("${url}")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  marginBottom: '24px',
  animation: `${fadeInUp} 0.4s ease forwards`,
  opacity: 0,
  borderRadius: '16px',
  maxWidth: '800px',
}));
